import React from 'react';
import firebase from "firebase/app";
import 'firebase/firestore';
import Cardmap from './apmap';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

export default function Dialogmap(props){
    const [geodestino, setageodestino] = React.useState(false);
    const [geosaida, setageosaida] = React.useState(false);
    const [geoparadasida, setageoparadasida] = React.useState(false);
    const [geoparadasvolta, setageoparadasvolta] = React.useState(false);

    React.useEffect(()=>{
        carregamapa(props.props);


        
      },[0])

      function carregamapa(props){
        var db = firebase.firestore();
        //console.log("user tipo poxa"+ lotacao + "puta merda q eu sei2");
        var query =  db.collection("agenda").doc(props).collection('direcoes').get().
        then(function(querySnapshot) { 
            querySnapshot.forEach(function(doc) {
                console.log("Document data:", doc.data());
                setageodestino(doc.data().geodestino);
                setageosaida(doc.data().geosaida);
                setageoparadasida(doc.data().geoparadasida);
                setageoparadasvolta(doc.data().geoparadasvolta);
            } )
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
      }

    

    return(
        <Cardmap   localdestino={geodestino} localsaida={geosaida} 
        listaparadasida={geoparadasida} listaparadasvolta={geoparadasvolta}          />
    )
}